export default "__VITE_ASSET__2GuHpsTc__"